/* eslint-disable no-void */
import * as vp from 'vopay';
import { useState, useEffect } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type HookTuple = [
  response: vp.InterestAccountTransactionsResponse,
  InterestAccountTransactionsRequest: (params: vp.InterestAccountTransactionsRequest) => void,
  reset: () => void,
];

type ApiHook = (props: HookProps) => HookTuple;

const useFetchInterestAccountTransactions: ApiHook = ({ api }: HookProps) => {
  const source = axios.CancelToken.source();
  const [response, setResponse] = useState<vp.InterestAccountTransactionsResponse>({
    ErrorMessage: '',
    Success: false,
    InterestAccountTransactions: undefined,
  });
  const [params, setParams] = useState<vp.InterestAccountTransactionsRequest>({
    InterestMaturityType: '',
    StartDate: '',
    EndDate: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    if (!shouldSendRequest) return () => {};

    const sendRequest = async (requestParams: vp.InterestAccountTransactionsRequest) => {
      setDataFetchingInfo(true, 'fetching interest account', 'fullScreen');
      const res = await api.fetchInterestAccountTransactions(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.InterestAccountTransactionsRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        ErrorMessage: '',
        Success: false,
        InterestAccountTransactions: undefined,
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchInterestAccountTransactions);
